import { colorAccentSuccess800, colorBrandYamahaRed, colorCoreBlack900Base, } from '@yme/tokens/colors';
import { STEP_STATE } from './constants';
export const getIconState = (state) => {
    if (state.isPassed) {
        return STEP_STATE.passed;
    }
    if (state.isCurrent) {
        return STEP_STATE.current;
    }
    return STEP_STATE.next;
};
export const getIconBorderColor = (state) => {
    const colors = {
        current: colorBrandYamahaRed,
        passed: colorAccentSuccess800,
        next: colorCoreBlack900Base,
    };
    return colors[state.toLowerCase()];
};
export const setStepsTitles = (labels) => {
    const { firstStepTitle, secondStepTitle, thirdStepTitle, fourthStepTitle } = labels;
    return [
        {
            isPassed: false,
            isCurrent: false,
            number: 1,
            title: firstStepTitle,
        },
        {
            isPassed: false,
            isCurrent: false,
            number: 2,
            title: secondStepTitle,
        },
        {
            isPassed: false,
            isCurrent: false,
            number: 3,
            title: thirdStepTitle,
        },
        {
            isPassed: false,
            isCurrent: false,
            number: 4,
            title: fourthStepTitle,
        },
    ];
};
export const getStepConfig = (stepsLabels, currentStep) => stepsLabels.map((item) => {
    if (item.number === currentStep) {
        return {
            ...item,
            isCurrent: true,
        };
    }
    if (item.number < currentStep) {
        return {
            ...item,
            isPassed: true,
            isCurrent: false,
        };
    }
    return item;
});
